/**
 * Form rules for the Demand Note's Custom Charge Amount, shared by the L1, L2
 * and L3 Demand Note forms so the three levels cannot drift apart.
 *
 * The amount is added to the Total as typed, so a negative value lowered the
 * Total while the Payment Details lists and the Demand Note PDF hid the row
 * (they show the custom charge only when it is above 0). The `min` rule makes
 * the form's handleSubmit stop the save and show the message under the field.
 * An empty field stays allowed: valueAsNumber turns it into NaN, which the
 * `min` check does not treat as below 0, and the Total reads it as 0.
 */
export const CUSTOM_CHARGE_AMOUNT_MIN = 0;

export const CUSTOM_CHARGE_AMOUNT_NEGATIVE_MESSAGE =
  "Custom Charge Amount cannot be negative";

export const customChargeAmountRules = {
  valueAsNumber: true,
  min: {
    value: CUSTOM_CHARGE_AMOUNT_MIN,
    message: CUSTOM_CHARGE_AMOUNT_NEGATIVE_MESSAGE,
  },
} as const;
